import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Single source of truth for the "Quick actions" tile grid used on every vendor
// dashboard. Keeps the look consistent and ensures features stay discoverable.
export default function QuickActions({ items, testid = "quick-actions" }) {
  if (!items?.length) return null;
  return (
    <section data-testid={testid}>
      <h2 className="font-heading text-xl font-bold mb-3">Quick actions</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {items.map(a => (
          <Link
            key={a.to}
            to={a.to}
            data-testid={a.testid || `qa-${a.to.split('/').pop()}`}
            className="group bg-surface border border-line rounded-2xl p-4 hover:-translate-y-0.5 hover:shadow-soft transition-all"
          >
            <div className={`w-9 h-9 rounded-xl grid place-items-center mb-2 ${a.color || "bg-brand/15 text-brand"}`}>
              <a.icon className="w-4 h-4"/>
            </div>
            <div className="font-heading font-extrabold text-sm flex items-center gap-1">
              {a.label}
              {a.badge && <span className="text-[9px] font-bold uppercase tracking-widest bg-brand text-white rounded-full px-1.5 py-0.5">{a.badge}</span>}
            </div>
            <div className="text-[11px] text-ink-soft mt-0.5">{a.desc}</div>
            <ArrowRight className="w-3 h-3 text-ink-soft group-hover:text-brand mt-1.5"/>
          </Link>
        ))}
      </div>
    </section>
  );
}
